import { api } from './api';
import type {
  BulkManifestationsResult,
  ManifestationCreate,
  ManifestationDetail,
  ManifestationKind,
  StoryCreate,
  StoryDetail,
  StorySummary,
  StoryUpdate,
} from '@/types/story';

export const storiesApi = {
  list: (params: { status?: string; search?: string; limit?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.status) qs.set('status', params.status);
    if (params.search) qs.set('search', params.search);
    if (params.limit) qs.set('limit', String(params.limit));
    return api.get<StorySummary[]>(`/stories?${qs}`);
  },
  get: (id: string) => api.get<StoryDetail>(`/stories/${id}`),
  create: (payload: StoryCreate) => api.post<StoryDetail>('/stories', payload),
  update: (id: string, payload: StoryUpdate) => api.put<StoryDetail>(`/stories/${id}`, payload),
  delete: (id: string) => api.delete<{ deleted: boolean }>(`/stories/${id}`),
  addManifestation: (storyId: string, payload: ManifestationCreate) =>
    api.post<ManifestationDetail>(`/stories/${storyId}/manifestations`, payload),
  bulkAddManifestations: (storyId: string, items: ManifestationCreate[]) =>
    api.post<BulkManifestationsResult>(`/stories/${storyId}/manifestations/bulk`, { items }),
  removeManifestation: (storyId: string, manifestationId: string) =>
    api.delete<{ removed: boolean }>(`/stories/${storyId}/manifestations/${manifestationId}`),
};

export const manifestationsApi = {
  findByRef: (kind: ManifestationKind, externalId: string) =>
    api.get<StorySummary[]>(`/manifestations/by-ref?kind=${kind}&external_id=${externalId}`),
};
